import styled from 'styled-components';

export const Container = styled.div`
  background: White;
  width: 680px;
  padding: 20px 50px 0 50px;
  margin: 20px auto 0 auto;
  border-top: solid 40px black;
`;

export const Logo = styled.img`
  float: right;
  max-width: 175px;
  margin-left: 30px;
`;

export const TitleAndLogo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const InfoText = styled.p`
  margin: 1em 0;
  color: ${(props) => props.theme.textLight};
`;

export const ImagesOption = styled.p`
  margin: 1em 0;
  color: ${(props) => props.theme.textLight};

  @media print {
    display: none;
  }
`;

export const KeyInfo = styled.div`
  margin: 26px 0;
`;

export const KeyInfoTable = styled.table`
  width: 99%;
  border: solid 1px #ccc;
  border-bottom: none;
  border-collapse: collapse;
  margin-bottom: 13px;

  tr:nth-child(odd) {
    background: #f0efeb;
  }

  tr {
    border-bottom: solid 1px ${(props) => props.theme.keyline};
  }

  th {
    border-bottom: solid 1px ${(props) => props.theme.keyline};
    border-right: solid 1px ${(props) => props.theme.keyline};
    padding: 10px;
    font-weight: bold;
    font-size: 13px;
    text-align: left;
  }

  td {
    border-bottom: solid 1px ${(props) => props.theme.keyline};
    padding: 10px;
    font-size: 13px;
  }
`;

export const AgentBox = styled.div`
  background: ${(props) => props.theme.backgroundLightest};
  color: ${(props) => props.theme.textLight};
  padding: 20px;
  border: solid 1px #ddd;
  margin: 30px 0;
`;

export const AgentInfo = styled.div`
  display: flex;
  width: 100%;
  margin-top: 21px;
`;

export const AgentNumber = styled.div`
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImageRow = styled.div`
  flex-direction: row;
  display: flex;
  margin-top: 10px;

  img {
    padding: 0 4px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }
`;

export const BottomBar = styled.div`
  height: 40px;
  background: black;
  color: white;
  margin: 0 auto 20px auto;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
`;

export const Content = styled.div`
  p {
    margin: 1em 0;
    color: ${(props) => props.theme.textDark};
  }
`;
